import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import UpdateCard from './UpdateCard';
import { getLatestUpdates } from './utils';

export default function LatestUpdates() {
  const updates = getLatestUpdates(2); // Reduced to 2 updates for better layout
  
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-16 bg-gradient-to-br from-green-50 to-emerald-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative">
          {/* Decorative elements */}
          <div className="absolute -top-6 -left-6 w-24 h-24 bg-green-200 rounded-full opacity-20" />
          <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-emerald-200 rounded-full opacity-20" />
          
          {/* Main content container */}
          <div className="relative bg-white rounded-2xl shadow-xl p-8 border border-green-100">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Left side - Updates */}
              <div className="space-y-6">
                {updates.map((update, index) => (
                  <UpdateCard key={update.id} update={update} index={index} />
                ))}
              </div>

              {/* Right side - Header and CTA */}
              <div className="flex flex-col justify-center lg:pl-8 lg:border-l lg:border-green-100">
                <motion.div
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  className="space-y-6"
                >
                  <div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-4">Latest News</h2>
                    <p className="text-lg text-gray-600">
                      Stay up to date with the latest happenings at CFSC
                    </p>
                  </div>
                  
                  <Link 
                    to="/events#top"
                    onClick={handleScrollToTop}
                    className="inline-flex items-center px-6 py-3 bg-green-600 text-white rounded-full 
                             hover:bg-green-700 transition-all transform hover:scale-105 shadow-md 
                             hover:shadow-lg"
                  >
                    View more
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Link>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}